// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"570":"locations-chunk","3356":"interactiveFabric","4056":"holy-stars","5210":"product-view-chunk"}[chunkId] || chunkId) + ".js?ver=" + __webpack_require__.h() + "";
};